import { render } from "./B2bTableMenuInventoryReport.vue?vue&type=template&id=fc7b9184&scoped=true&lang=pug"
import script from "./B2bTableMenuInventoryReport.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuInventoryReport.vue?vue&type=script&lang=js"

import "./B2bTableMenuInventoryReport.vue?vue&type=style&index=0&id=fc7b9184&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc7b9184"]])

export default __exports__